import { TOUCH_BUFFER_MS } from '@angular/cdk/a11y';
import { Component, OnInit, VERSION, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { APIService } from 'src/app/api.service';
import { CommonService } from 'src/app/services/common.service';
import * as xlsx from 'xlsx';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { formatDate, DatePipe } from '@angular/common';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { localizedString } from '@angular/compiler/src/output/output_ast';
import { NgxSpinnerService } from 'ngx-spinner';
import { Title } from '@angular/platform-browser';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';



@Component({
  selector: 'app-item-transaction-log',
  templateUrl: './item-transaction-log.component.html',
  styleUrls: ['./item-transaction-log.component.scss']
})
export class ItemTransactionLogComponent implements OnInit {
  name = 'Angular ' + VERSION.major;
  selecetdMonth: any;

 
  // constructor(private router: Router, private commonService: CommonService, 
  //             private apiService: APIService) { }

    constructor(private dateAdapter: DateAdapter<Date>, private commonService: CommonService, private titleSer: Title, private apiService: APIService, private modalService: NgbModal, private router: Router, private loadingPnl: NgxSpinnerService) {
      this.dateAdapter.setLocale('en-IN');
      this.loadItems();
    }

  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
    //this.dataSource.sort = this.matSort;
    this.dataSource.sortingDataAccessor = (item: any, property) => {
      switch (property) {
        case 'Date': return new Date(item.XnDT);
        default: return item[property];
      }
    }
  }

  pipe = new DatePipe('en-IN');
  curDate: any = new Date();
  selectedFY: any;
  fromDate: Date = new Date('2021-Apr-01');
  toDate: Date = new Date('2022-Mar-31');
  acctStartDT: Date = new Date();
  month = this.curDate.getMonth() + 1;
  year = this.curDate.getFullYear();
  Date: Array<any> = [];
  ERP_Agn: Array<any> = [];
  financialYears: any = [];
  itemtrasactionHistoryList: any = [];
  tempItemTransDataList: any = [];
  agencyData: any = [];
  jarvisData: any = [];
  relativeData: any = [];
  userList: any = [];
  storeList: any = [];
  itemList: any = [];
  months: any = [];
  countData: any = [];
  monthDisplay: any
  exportToExcel: any = [];
  isTransType = false;
  unitList: Array<any> = [];
  transTypeName: string = '';
  NewItemName: string = '';
  date = new Date();
  lastMonth: any = new Date(new Date().getFullYear(), new Date().getMonth() + 0, 1);
  startDate: any = new Date(new Date(this.lastMonth));
  endDate: any = new Date(new Date());
  prdQty: any = 0;
  period: any = 1;
  maxDate = new Date();

  itemCtrl = new FormControl(0);
  filteredItems!: Observable<any[]>;

  transType = {
    id: 0,
    name: ""
  };

  item = {
    id: 0,
    name: ""
  };

  displayedColumns: string[] = ['Date', 'transTypeName', 'XnNo', 'relativeName', 'NewoutStoreName', 'IQty', 'OQty', 'Unit', 'XnByUser', 'XnNotes', 'Action'];

  transactionType: any = [
    {
      id: 0,
      type: "All Transactions"
    },
    {
      id: 1,
      type: "GRN Inward"
    },
    {
      id: 2,
      type: "Return Unused"
    },
    {
      id: 3,
      type: "Customer Return"
    },
    {
      id: 4,
      type: "Dispatch"
    },
    {
      id: 5,
      type: "Issue"
    },
    {
      id: 6,
      type: "Scrap/Disposal"
    },
    {
      id: 7,
      type: "Production"
    },
    {
      id: 8,
      type: "Reconciliation"
    },
    {
      id: 9,
      type: "Store transfer"
    },
    {
      id: 10,
      type: "Basic Production"
    },
    {
      id: 12,
      type: "Job Work (Out) - Dispatch"
    },
    {
      id: 13,
      type: "Job Work (Out) - Receive"
    }
  ];
  dateFilter = {
    showDateRange: false,
    fromMinDT: null,
    fromMaxDT: null,
    toMinDT: null,
    toMaxDT: null
  };

  ngOnInit(): void {

    this.pageTitle();

    let tmpERP_Agn = this.apiService.getCookie('ERP_Agn');
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
    }
    
    this.months = this.commonService.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date());
    this.months = this.months.reverse();
    this.monthDisplay = this.months[0].display;
    //Get Account Start DT
    if (this.ERP_Agn.length > 0) {
      this.acctStartDT = new Date(this.ERP_Agn[0].AccountStartDT);
    }
    // console.log("lastMonth", this.lastMonth);
    let accountsDate: any = this.apiService.getCookie('AccountsDates');
    if (accountsDate) {
      accountsDate = JSON.parse(accountsDate);
      if (accountsDate.length > 0) {
        this.selectedFY = accountsDate[0].selectedFy;
        this.toDate = new Date(accountsDate[0].tdt);
        // this.toDate=this.toDate.replace(/%20/g, " ");
        this.fromDate = new Date(accountsDate[0].fdt);
      }
    }

    this.financialYears = this.commonService.checkFinancialYear(
      this.acctStartDT,
      new Date()
    );

    let cnfg = this.apiService.getCookie('ERP_Cfg');
    if (cnfg) {
      let cnfg1 = JSON.parse(cnfg);
      this.storeList = JSON.parse(cnfg1[0].Stores);
      let unit = cnfg1[0].Units;
      console.log("unit", unit)
      if(unit){
        this.unitList = JSON.parse(unit);
      }      
    }

    if (this.item.id != 0) {
      this.getData();
    } 

    this.isTransType = true;

    this.typeFilter(1);

    this.itemCtrl.valueChanges.subscribe(value => {
        this.item.id = value;  // Keep the item.id in sync with the form control
    });
  }

  //typeFilter() - 
  typeFilter = (obj: any) => {
    this.period = obj;
    if (this.period == 1) {
      this.prdQty = 0;
      this.trasYearChange();
    }
    else if(this.period == 2) {
      this.startDate = new Date(this.year + '-' + this.month + "-01");
      this.endDate = new Date(this.year, this.month, 0);
    }
  }

  //fn_ChangeDate() - 
  fn_ChangeDate() {
    this.prdQty = this.monthDiff(new Date(this.startDate), new Date(this.endDate));
    this.year = new Date(this.startDate).customFormat('#YYYY#');
    this.month = new Date(this.startDate).customFormat('#MM#');
    this.dateFilter.toMinDT = this.startDate;
    if(this.startDate > this.endDate) {
      this.endDate = this.startDate;
    }
    this.getData();
  }

  //monthDiff() - 
  monthDiff(dateFrom: Date, dateTo: Date) {
    return dateTo.getMonth() - dateFrom.getMonth() + 
      (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
  }

  trasYearChange() {
    let selecetdYear = this.months.filter((a: any) => a.display == this.monthDisplay);
    this.prdQty = 0;
    this.year = selecetdYear[0].year;
    this.month = selecetdYear[0].number;
    let filterRange = this.commonService.getDateRange("Other Month", this.month, this.year);
    this.startDate = filterRange.startDate;
    this.endDate = filterRange.endDate;
    this.dateFilter.toMinDT = filterRange.startDate;
    this.dateFilter.toMaxDT = filterRange.endDate;
    this.dateFilter.fromMinDT = filterRange.startDate;
    this.dateFilter.fromMaxDT = filterRange.endDate;
    this.getData();
  };

  ChangeTransType() {
    let trasType = this.transactionType.filter((x: any) => x.id == this.transType.id);
    this.transType.id = trasType[0].id;
    this.transTypeName = trasType[0].type;
    if (this.transType.id == 0) {
      this.getData();
    }
    else {
      this.tempItemTransDataList = this.itemtrasactionHistoryList.filter((x: any) => x.XnTypeID == this.transType.id);
      this.dataSource.data = this.tempItemTransDataList;
      this.exportToExcel = this.tempItemTransDataList;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.matSort;
    }
  }

  private _filterItems(value: any): any[] {
    // Handle both string values and object values
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.ItemName?.toLowerCase() || '';
        
    if (!this.itemList) return [];
    
    return this.itemList.filter((item: any) => 
        item.ItemName && item.ItemName.toLowerCase().includes(filterValue)
    );
  } 

  displayFn(item: any): string {
    return item && item.ItemName ? item.ItemName : '';
  }

  loadItems() {
    this.apiService.getIDB('erp_inv', (item: any) => {
      if (item && item.length > 0) {
        this.itemList = item;
        this.filteredItems = this.itemCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filterItems(value || ''))
        );
      }
    });
  }

  ChangeItem() {
    const selectedItem = this.itemCtrl.value;
    if (selectedItem && selectedItem.ItemID) {
        this.item.id = selectedItem.ItemID;
        this.NewItemName = selectedItem.ItemName;
        this.getData();
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  backBtn() {
    this.router.navigate(['/Stock']);
  }


  getData() {
    let agencyData = this.apiService.getCookie('M');
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    let userList = this.apiService.getCookie('J');
    if (userList) {
      this.userList = JSON.parse(userList);
    }

    var jarvis = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    let data = [
      {
        Month: this.month,
        Year: this.year,
        ItemID: this.item.id ? this.item.id : 0,
        PrdQty: this.prdQty,
      },
    ];
    let myParams = [
      {
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'getItmTransLog',
        moduleID: 12,
        data: JSON.stringify(data),
      },
    ];
    this.loadingPnl.show();
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this)
    );
  }

  successResp(res: any) {
    // this.SpinnerService.hide();
    this.loadingPnl.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);

        if (reponseData.Table[0].ErrCode == 1000) {
          alert(reponseData.Table[0].ErrMsg);
          window.location.href = "main.html#/home";
          // this.router.navigateByUrl('/Stock');
        } else if(reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert('Please select a valid period.')
          this.dataSource.data = [];
        } else {
          //Get H from IDB
          var self = this;
          this.apiService.getIDB('H', function(dataList: any){
            if(dataList){
              self.relativeData = dataList;
            }
            if (reponseData.Table[0].ErrCode == -1) {
              self.countData = reponseData.Table1;
              self.itemtrasactionHistoryList = reponseData.Table2;
              console.log("XnsHistory", self.itemtrasactionHistoryList);
              if(self.dateFilter.showDateRange){
                self.itemtrasactionHistoryList = self.itemtrasactionHistoryList.filter((o: any) => new Date(new Date(o.XnDT).customFormat("#DD#-#MMM#-#YY#")) >= new Date(self.startDate) && new Date(new Date(o.XnDT).customFormat("#DD#-#MMM#-#YY#")) <= new Date(self.endDate));
              }
  
              self.itemtrasactionHistoryList.forEach((p: any) => {
                let selectedUnit = self.unitList.filter((x: any) => x.UNm == p.Unit);
                if(selectedUnit.length > 0){
                  p.Prcsn = selectedUnit[0].Prcsn;
                }
  
                 p.IQty = self.commonService.PrecisionwiseValue(p.IQty + "", p.Prcsn, 1);
                p.OQty = self.commonService.PrecisionwiseValue(p.OQty + "", p.Prcsn, 1);
  
                p.NewoutStoreName = '';
  
                if (p.IStrID) {
                  let inStore = self.storeList.filter((x: any) => x.StrID == p.IStrID);
                  p.inStoreName = inStore[0].sNm;
                }
                if (p.OStrID) {
                  let outStore = self.storeList.filter((x: any) => x.StrID == p.OStrID);
                  p.outStoreName = outStore[0].sNm;
                  p.NewoutStoreName = outStore[0].sNm;
                }
                if (p.XnTypeID) {
                  let transType = self.transactionType.filter((x: any) => x.id == p.XnTypeID);
                  p.transTypeName = transType[0].type;
                  // p.TranName = transType[0].type;
                }
                // If store transfer, show to store in other details 
                if (p.XnTypeID == 9 && p.inStoreName) {
                  p.relativeName = 'To : ' + p.inStoreName;
                }
                //04-26-2023
                // if (p.XnByUserID) {
                //   let userid = self.userList.filter((x: any) => x.UserID == p.XnByUserID);
                //   p.transUserName = userid[0].Name;
  
                // }
                if(p.XnByUser){
                  p.transUserName = p.XnByUser
                }
  
                p.Date = new Date(p.XnDT).customFormat('#DD#-#MMM#-#YY#')
                // p.targetDate = new Date(p.TargetDT);
                if (p.RelativeID > 0) {
                  let relativetempData = self.relativeData.filter((x: any) => x.RI == p.RelativeID)
                    if(relativetempData.length > 0){
                      p.relativeName = relativetempData[0].Cmp
                    }
                    else{
                      p.relativeName = "";
                    }
                }
              });
  
              if (self.transType.id) {
                self.tempItemTransDataList = self.itemtrasactionHistoryList.filter((x: any) => x.XnTypeID == self.transType.id)
                self.dataSource.data = self.tempItemTransDataList;
                self.exportToExcel = self.tempItemTransDataList;
                self.dataSource.paginator = self.paginator;
                self.dataSource.sort = self.matSort;
              }
              else {
                self.dataSource.data = self.itemtrasactionHistoryList;
                self.exportToExcel = self.itemtrasactionHistoryList;
                self.dataSource.paginator = self.paginator;
                self.dataSource.sort = self.matSort;
              }
            }
          })
          
        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    this.loadingPnl.hide();
    if (res.error) {
    } else {
      alert(res.message);
    }
  }

  showDateRangePicker(){
    this.dateFilter.showDateRange = !this.dateFilter.showDateRange;
  }

  printTranjection(id: number) {
    let XnID = this.commonService.encryptData(id);
    let AgencyID = this.commonService.encryptData(this.jarvisData[0].AgencyIDs);
    window.open('transactionHistory?XnID=' + XnID + "&aid=" + AgencyID, '_blank', 'Height= 800px, Width= 1000px, padding:10px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
  }

  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
      , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

    return function (table: any, name: string, fileName: any) {
      if (!table.nodeType) table = table
      var ctx = { worksheet: name || 'Worksheet', table: table }
      //window.location.href = uri + base64(format(template, ctx))
      var link = document.createElement("a");
      link.download = fileName || 'download.xls';
      link.href = uri + base64(format(template, ctx));
      link.click();
    }
  })()



  //Export To Excel
  exportToExcelActivities() {
    var html = "";
    // Title
    html += "<table><tr>";
    html += "<th style='text-align: left;'>Item Transaction Log</th>"
    html += "</table></tr>";

    html += "<table><tr></table></tr>";
    html += "<table><tr>";

    //Hader Title
    if(this.dateFilter.showDateRange == false)
    {
    html += "<p><b> Month : </b>" + this.monthDisplay + "<b>, Type : </b>" + (this.transType.id == 0 ? 'All' : this.transTypeName) + "<b>, Item : </b>" + (this.item.id == 0 ? 'All' : this.NewItemName) + "</p>"
    }
    else
    {
      html += "<p><b> Date : </b>" + new Date(this.startDate).customFormat("#DD#-#MMM#-#YYYY#") + " - " + new Date(this.endDate).customFormat("#DD#-#MMM#-#YYYY#") + "<b>, Type : </b>" + (this.transType.id == 0 ? 'All' : this.transTypeName) + "<b>, Item : </b>" + (this.item.id == 0 ? 'All' : this.NewItemName) + "</p>"

    }
    // Blank Column
    html += "<table><tr>";

    var strHeader = ""
    strHeader += "<th style='text-align: left;'>Date</th>";
    strHeader += "<th style='text-align: left;'>Trans Type</th>";
    strHeader += "<th style='text-align: left;'>Transaction No</th>";
    strHeader += "<th style='text-align: left;'>Other Details</th>";
    strHeader += "<th style='text-align: left;'>Store</th>";
    strHeader += "<th style='text-align: left;'>In Qty</th>";
    strHeader += "<th style='text-align: left;'>Out Qty</th>";
    strHeader += "<th style='text-align: left;'>Unit</th>";

    strHeader += "<th style='text-align: left;'>Executive</th>"
    strHeader += "<th style='text-align: left;'>Notes</th>";
    

    strHeader += "</tr>"
    html += strHeader;
    var body = "";

    this.exportToExcel.forEach((item: any, key: any) => {
      body += "<tr>";
      item.Date = (item.Date == null) ? '-' : new Date(item.Date).customFormat("#DD#-#MMM#-#YYYY#");
      body += "<td style='text-align: left;'>" + item.Date + "</td>";
      body += "<td style='text-align: left;'>" + item.transTypeName + "</td>";
      body += "<td style='text-align: left;'>" + item.XnNo + "</td>";
      body += "<td style='text-align: left;'>" + (item.relativeName ? item.relativeName : '-') + "</td>";
      body += "<td style='text-align: left;'>" + (item.NewoutStoreName ? item.NewoutStoreName : item.inStoreName) + "</td>";
      body += "<td style='text-align: right;mso-number-format: \"#,##0.00\"''>" + item.IQty + "</td>";
      body += "<td style='text-align: right;mso-number-format: \"#,##0.00\"''>" + item.OQty + "</td>";
      body += "<td style='text-align: left;'>" + item.Unit + "</td>";
      
      body += "<td style='text-align: left;'>" + (item.XnByUser ? item.XnByUser : '-') + "</td>";
      body += "<td style='text-align: left;'>" + (item.XnNotes ? item.XnNotes : '-') + "</td>";

      body += "</tr>";
    })

    // this.exportToExcel.forEach((item:any, key:any) => {
    //   body += "<tr>";
    //   item.Date = (item.Date == null) ? '-' : new Date(item.Date).customFormat("#DD#-#MMM#-#YYYY#");
    //   body += "<td style='text-align: left;'>" + item.Date + "</td>";
    //   body += "<td style='text-align: left;'>" + item.transTypeName + "</td>";
    //   body += "<td style='text-align: left;'>" + item.XnNo + "</td>";
    //   body += "<td style='text-align: left;>" +  (item.relativeName ? item.relativeName : '-') + "</td>";
    //   body += "<td style='text-align: left;'>" +  (item.NewoutStoreName ? item.NewoutStoreName : item.inStoreName) + "</td>";
    //   body += "<td style='text-align: right;mso-number-format: \"#,##0.00\"''>" +  item.IQty + "</td>";
    //   body += "<td style='text-align: right;mso-number-format: \"#,##0.00\"''>" +  item.OQty + "</td>";
    //   body += "<td style='text-align: left;'>" +  (item.XnNotes ? item.XnNotes : '-') + "</td>";
    // body += "</tr>";
    // })
    html += body;
    html += "</table>";
    this.tableToExcel(html, 'Sheet1', 'Item Transaction Log');
  }

  pageTitle(){
    setTimeout(() => {
        var header = $('.lblHeader').text();
        if(!header){
            header = "Biziverse"
        }
        else{
            header = header + " - Biziverse";
        }
        this.titleSer.setTitle(header);
    }, 200);
    
}
 



}
function getDiffDays(sDate: any, eDate: any) {
  throw new Error('Function not implemented.');
}

